import { LabelWithGuideline } from "./LabelWithGuideline"

export default LabelWithGuideline;